import { useSelector } from "react-redux";
import { esCO } from "./esCO";
import { languages } from "./languages";
function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}
export const useLanguage = () => {
    var _a;
    const currentLanguage = useSelector(x => { var _a; return (_a = x === null || x === void 0 ? void 0 : x.language) === null || _a === void 0 ? void 0 : _a.currentLanguage; }) || 'es-CO';
    const result = (_a = languages[currentLanguage]) !== null && _a !== void 0 ? _a : esCO;
    return Object.assign(Object.assign({}, result), { __replace: (value, replacement) => {
            for (const key in replacement) {
                if (Object.prototype.hasOwnProperty.call(replacement, key)) {
                    const replacementValue = replacement[key];
                    value = replaceAll(value !== null && value !== void 0 ? value : '', `{{${key}}}`, String(replacementValue));
                }
            }
            return value;
        } });
};
